import { Injectable } from '@angular/core';
import { SuggestionService } from './suggestion.service';
import { DataIndexClientService } from '@mode/queries/schemas/data-access';

@Injectable()
export class DataIndexSuggestionService implements SuggestionService {
  constructor(private dataIndexClient: DataIndexClientService) {}

  async getTables(): Promise<AceAjax.Completion[]> {
    return [] as AceAjax.Completion[];
  }

  async getColumns() {
    return [] as AceAjax.Completion[];
  }

  async getDefinition() {
    return null;
  }
}
